import React from 'react';
import { AppContext } from '../../HomePage';
import './AdminPageHeader.css';

// Shared header for admin management pages. Gives every page one identity:
// a back-to-hub link, a title + optional subtitle, and an optional right-side
// actions slot (toolbar buttons / search). Purely presentational.
const AdminPageHeader = ({ title, subtitle, backToHub = true, actions }) => {
  const { t } = React.useContext(AppContext);

  return (
    <div className="admin-page-header">
      <div className="admin-page-header-main">
        {backToHub && (
          <a
            className="admin-page-header-back"
            href="#/management"
            title={t('menu.management_hub.title')}
            aria-label={t('menu.management_hub.title')}
          >
            <i className="pi pi-arrow-left" />
          </a>
        )}
        <div className="admin-page-header-titles">
          <h2 className="admin-page-header-title">{title}</h2>
          {subtitle && <p className="admin-page-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="admin-page-header-actions">{actions}</div>}
    </div>
  );
};

export default AdminPageHeader;
